export const fetchGoogleClientId = () => {
  let clientId = '';
  if (window.ga) {
    window.ga("create", process.env.GOOGLE_TRACKER_ID, "auto");
    window.ga(function(tracker) {
      clientId = tracker.get("clientId");
    });
  }
  return clientId;
};
